import * as Types from "../types";

export const setConfirmWallet = (payload) => ({
  type: Types.CONFIRM_WALLET,
  payload,
});

export const setCheckWallet = (payload) => ({
  type: Types.CHECK_WALLET,
  payload,
});

export const setExitWallet = () => ({
  type: Types.EXIT_WALLET,
});
